/** Brand-refresh helpers for Store Details (ticket 18774). */

/**
 * API / slug responses often return "0" / "0 mi" when there is no search origin.
 * Treat those as missing so we do not show a fake "0 Miles".
 */
export const isMissingBrandRefreshStoreDistance = (distance) => {
  if (distance == null || distance === '') {
    return true;
  }
  const numeric = parseFloat(String(distance).replace(/[^\d.]/g, ''));
  return Number.isNaN(numeric) || numeric === 0;
};

export const formatBrandRefreshStoreDistance = (distance) => {
  if (isMissingBrandRefreshStoreDistance(distance)) {
    return '';
  }

  return String(distance).replace(/\s*mi\b/i, ' Miles');
};

/**
 * Format miles to match storeSearch-style strings ("6.9 mi") before display formatting.
 */
export const formatMilesAsStoreDistance = (miles) => {
  if (miles == null || Number.isNaN(miles) || miles <= 0) {
    return '';
  }
  const rounded = Math.round(miles * 10) / 10;
  return `${rounded} mi`;
};

export const formatBrandRefreshStorePhone = (phone) => {
  if (!phone) {
    return phone;
  }

  const digits = String(phone).replace(/\D/g, '');
  let national = digits;

  if (digits.length === 11 && digits.charAt(0) === '1') {
    national = digits.slice(1);
  } else if (digits.length !== 10) {
    return phone;
  }

  const area = national.slice(0, 3);
  const mid = national.slice(3, 6);
  const last = national.slice(6, 10);
  return `+1 (${area}) ${mid} ${last}`;
};
